import { FC } from "react";
import { Box } from "@mui/material";
import { makeSxStyles } from "ui";

export interface OrganizationAccessToggleProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  "data-testid"?: string;
}

const OrganizationAccessToggle: FC<OrganizationAccessToggleProps> = ({
  checked,
  onChange,
  disabled,
  "data-testid": dataTestId,
}) => {
  const styles = useStyles();

  return (
    <Box
      component="button"
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={onChange}
      sx={checked ? styles.trackOn : styles.trackOff}
      data-testid={dataTestId}
    >
      <Box sx={checked ? styles.handleOn : styles.handleOff} />
    </Box>
  );
};

const useStyles = makeSxStyles(({ palette: { primary, grey } }) => ({
  trackOn: {
    position: "relative",
    display: "inline-block",
    width: "39px",
    height: "24px",
    borderRadius: "75px",
    padding: 0,
    boxSizing: "border-box",
    cursor: "pointer",
    border: "none",
    background: primary.main,
    "&:disabled": { cursor: "default", opacity: 0.5 },
  },
  trackOff: {
    position: "relative",
    display: "inline-block",
    width: "39px",
    height: "24px",
    borderRadius: "75px",
    padding: 0,
    boxSizing: "border-box",
    cursor: "pointer",
    background: grey[500],
    border: `1.5px solid ${grey[300]}`,
    "&:disabled": { cursor: "default", opacity: 0.5 },
  },
  handleOn: {
    position: "absolute",
    top: "50%",
    right: "3px",
    transform: "translateY(-50%)",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    background: "#00344E",
  },
  handleOff: {
    position: "absolute",
    top: "50%",
    left: "3px",
    transform: "translateY(-50%)",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    background: grey[300],
  },
}));

export default OrganizationAccessToggle;
